export default {
  // Định dạng excel
  Excel: 1,

  // Định dạng văn bản word
  Word: 2,

  // Định dạng PDF
  PDF: 3,
}
